<template>
    <div class='wrap'>
        <div class='head'>
            <p class="headOne">INTERNET HOSPITAL SYSTEM</p>
            <p class="headTwo">互联网医院系统</p>
            <p class='headThree'>数据信息统一化+<br>丰富医疗服务内容+拓展医疗资源辐射范围</p>
            <img class='videoStart' src='./../../../assets/Pc/banner2.png'>
        </div>
        
        <div class='titleBox'>
            智慧医疗  无缝互联
            <img class='down' src="./../../../assets/Mobile/Boao/downL.gif" alt="">
        </div>
        <div class='titleBoxTwo'>
            <p class='titleOne'>TELEMEDICINE SYSTEM</p>
            <p class='titleTwo'>远程医疗系统</p>
        </div>
        <img class='centerImg' src="./../../../assets/Mobile/solution/solutionTwo.png" alt="">
        <p class='titleTwo'>产品优势</p>
        <ul class='content'>
            <li class='contentText'>
                <span class="boradius"></span>
                <p class="contentTextTitle">大幅增加便捷性</p>
                <div class="contentTextCon">
                    <i class="iconfont rigTringle">&#xe785;</i>
                    改会诊中心接入模式为多屏接入模式：医生通过电脑、手机、会诊中心均可以接入远程医疗系统，便于在省市及地方县镇乡村广泛落地，极大降低了落地成本，加快了落地效率。
                    <br><i class="iconfont rigTringle">&#xe785;</i>
                    改会诊中心对会诊中心模式为医生对医生模式：基于会诊中心制定的会诊流程和管理制度，医生与医生之间能够自主发起会诊，使复杂流程得以简化，大幅增加会诊便利性，并大幅降低会诊中心的工作量。
                    <br><i class="iconfont rigTringle">&#xe785;</i>
                    改病历手动复制为病历自动提取：会诊病历数据可以通过与院内系统对接的方式，实现数据的自动同步，便捷医生操作，并有效提高会诊质量。
                                   
                </div>
            </li>
            <li class='contentText'>
                <span class="boradius"></span>
                <p class="contentTextTitle">
                    激励明确并及时发放到位
                </p>
                <div class="contentTextCon">
                    制定合理规范的激励政策和绩效考核制度，有专门的财务系统后台，通过自动化结算系统，实现会诊后医生诊费的及时获得并合规完税
                </div>
            </li>
            <li class='contentText'>
                <span class="boradius"></span>
                <p class="contentTextTitle">
                    会诊全过程严格监管
                </p>
                <div class="contentTextCon">
                    根据《远程会诊管理办法》，使用安全等级合规的服务器，获取规范的数据报告，实现重要数据的备份监管。
                </div>
            </li>
            <li class='contentText contentTextNone'>
                    <span class="boradius"></span>
                    <p class="contentTextTitle">
                        建立统一的医生协作平台
                    </p>
                    <div class="contentTextCon">
                        医生通过医生端APP与院内院外医生互动，有效实现跨区域互动社交，实现医生的社交需求，促成会诊合作团队的广泛建成。
                    </div>
                </li>
        </ul>
        <div class='titleBoxTwo'>
            <p class='titleOne'>INTERNET HOSPITAL SYSTEM</p>
            <p class='titleTwo'>互联网医疗系统</p>
        </div>
        <img class='centerImg' src="./../../../assets/Mobile/solution/solutionOne.png" alt="">
        <p class='titleTwo'>产品优势</p>
        <ul class='content contentTwo'>
            <li class='contentText'>
                <span class="boradius"></span>
                <p class="contentTextTitle">
                    数据信息统一化
                </p>
                <div class="contentTextCon">
                    基于各业务场景的需求，建设统一支付平台、统一患者信息管理平台、统一电子病历平台，实施标准化基础数据管理。
                </div>
            </li>
            <li class='contentText'>
                <span class="boradius"></span>
                <p class="contentTextTitle">
                    丰富医疗服务内容
                </p>
                <div class="contentTextCon">
                    巩固医疗机构现有基础服务，同时发挥互联网医院体制优  势，推动健康管理和私人医生等服务。通过数据化运营，使智能化医疗服务逐渐具备可实施性。
                </div>
            </li>
            <li class='contentText contentTextNone'>
                <span class="boradius"></span>
                <p class="contentTextTitle">
                    拓展医疗资源辐射范围
                </p>
                <div class="contentTextCon">
                    基于医联体、远程协作等服务，互联网医疗服务具备推广优势，可将优质医疗资源带入更广范围。
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        data(){
            return {

            }
        }
    }
</script>
<style lang="less" scoped>
.head {
    width: 100%;
    height: 413px;
    background: url('./../../../assets/Mobile/solution/solutionHead.png') no-repeat;
    background-size: 100% 100%;
    background-color:linear-gradient(128deg,rgba(59,167,234,1),rgba(59,78,222,1),rgba(59,78,222,1));
    font-family:NotoSansHans-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: left;
    padding-top: 77px;
    margin-bottom:20px;
    position: relative;
    .headOne{
        margin-bottom:14px;
        font-size:24px;
        font-family:PangMenZhengDao;
        font-weight:400;
        color:#CECECE;
        padding-left: 20px;
        line-height:40px;
    }
    
    .headTwo{
        font-size:28px;
        padding-left: 20px;
        font-family:NotoSansHans-Bold;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:50px;
        margin-bottom: 10px;
    }
    .headThree{
        padding-left: 20px;
        font-family:NotoSansHans-Bold;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:48px;
        font-size:22px;
    }
    .videoStart{
        position: absolute; right: 26px; top: 7px;
        width:534px;
    }
}
// 标题
.titleBox{
    font-size:28px;
    font-family:NotoSansHans-Medium;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:36px; 
    text-align:center;
    // margin-bottom:34px;
    .down{
        width: 46px; display: block; margin:30px auto 60px; 
    }
}
.titleBoxTwo{
    text-align:center;
    margin-bottom:70px;
    .titleOne{
        font-size:24px;
        font-family:PangMenZhengDao;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:30px;
        background:linear-gradient(176deg,rgba(61,170,246,1) 7.5439453125%, rgba(174,195,255,1) 99.5849609375%);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
    }
    .titleTwo{
        font-size:24px;
        font-family:NotoSansHans-Bold;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:30px;
    }
}
// 图片
.centerImg{
    width: 713px; margin: 0 auto; display: block; margin-bottom:47px;
}
// 内容
.content{
    width: 670px; margin: 0 auto 100px;
    .contentText{
        position: relative; padding-left: 30px; margin-bottom:10px; border-left: 2px dashed #C2E2FF;
        .boradius{
            position: absolute; left: -8px; top: 0; width: 16px; height: 16px; display: block; border-radius: 50%; background: #C2E2FF; 
        }
        .contentTextTitle{
            font-size: 24px; 
            /* line-height: 42px; */
             color: #3576E0; font-family: NotoSansHans-Light;
            font-weight:300;
            margin-bottom: 10px;
        }
        .contentTextCon{
            font-size:24px;
            font-family:NotoSansHans-Light;
            font-weight:300;
            color: #333333;
            line-height:45px;
            .rigTringle{
                color:#FFC600; margin: 0 0px 0 0; font-size: 32px;
            }
        }
    }
    .contentTextNone{
        border: none;
    }
}
/* 产品优势 */
.titleTwo{
    font-size:24px;
    font-family:NotoSansHans-Medium;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:30px;
    text-align: center;
    margin-bottom: 50px; display: block;
}
.contentTwo{
    margin-bottom: 140px;
}
</style>